<script>
  import request from "superagent";
  import { _ } from "svelte-i18n";

  export let newUser;
  export let user;

  let displayLoginForm = false;
  let phone = "";
  let countryCode = "47";
  let challenge;
  let message;
  let code;
  let loading;
  let sentBySMS;

  function requestAuthenticationCode() {
    loading = true;
    request
      .post("/api/login")
      .send({ phone: phone, country: countryCode })
      .then((response) => {
        ({ challenge, sentBySMS } = response.body);
        message = undefined;
        loading = false;
      })
      .catch((error) => {
        message =
          "Ukjent telefonnummer, (" + error.status + " " + error.message + ")";
        loading = false;
      });
  }

  function decrypt() {
    loading = true;
    request
      .post("/api/authenticate")
      .send({ challenge: challenge, code: code.toUpperCase() })
      .then((response) => {
        loading = false;
        user = response.body;
        localStorage.setItem("user", JSON.stringify(user));
        window.location.href = "/profil";
      })
      .catch((error) => {
        loading = false;
        message = "Feil kode, (" + error.status + " " + error.message + ")";
      });
  }
</script>

<div class="card">
  {#if displayLoginForm}
    <section class="card__section">
      <h3 class="h4">{$_("login.alreadyUser")}</h3>
      {#if challenge}
        <label for="tel" class="input"
          ><span class="input__label">{$_("login.form.info")}</span>
          {#if !sentBySMS}
            <span class="form-error is-visible"
              >{$_("login.form.error1")}
              <a
                style="text-decoration:underline"
                href="sms:+4790508006;?&body=Hei! Treningsdagbok tilgang, kan du sende meg koden jeg trenger? "
                >{$_("login.form.error2")}
                <span style="white-space: no-wrap">905 08 006</span></a
              >
              {$_("login.form.error3")}</span
            >
          {/if}
          <input
            pattern="[0-Z]*"
            style="text-transform: uppercase"
            type="text"
            placeholder={$_("login.form.code.placeholder")}
            name="code"
            bind:value={code}
            class="input__text input__text--size-md"
            id="tel"
          /></label
        >
      {:else}
        <label for="tel" class="input"
          ><span class="input__label">{$_("login.form.phone.label")}</span>
          <div
            class="input__text input__text--size-md"
            style="display:flex; flex-direction: row;"
          >
            <span style="padding: 0px; width: 10px; color: grey;">+</span>
            <input
              style="padding: 0px; width: 25px; color: grey;"
              type="countyCode"
              inputmode="numeric"
              name="country"
              bind:value={countryCode}
              id="countyCode"
            />
            <input
              style="padding: 0px; width: 100%;"
              type="tel"
              pattern="[0-9]*"
              inputmode="numeric"
              name="mobile"
              bind:value={phone}
              id="tel"
            />
          </div></label
        >
      {/if}
      {#if message}
        <span class="form-error is-visible">{message}</span>
      {/if}
      <button
        on:click|preventDefault={challenge
          ? decrypt
          : requestAuthenticationCode}
        class="button button--icon button--icon-link {loading
          ? 'is-disabled button--disabled'
          : ''}"
        >{challenge ? $_("login.login") : $_("login.form.getCode")}</button
      >
      <div>
        <button
          on:click={() => (displayLoginForm = false)}
          type="button"
          class="button-text button-text--cancel"
          >{$_("generic.buttons.cancel")}</button
        >
      </div>
    </section>
  {:else}
    <section class="card__section">
      <h3 class="h4">{$_("login.alreadyUser")}</h3>
      <button
        on:click|preventDefault={() => (displayLoginForm = true)}
        class="button button--icon button--icon-login"
        >{$_("login.form.submit")}</button
      >
    </section>
    <section class="card__section">
      <h3 class="h4">{$_("login.becomeUser")}</h3>
      <div class="signup-choice">
        <a
          on:click|preventDefault={newUser.athlete}
          class="signup-choice__link signup-choice__link--athlete"
          href="/bli-bruker"
          ><span class="signup-choice__link-text">{$_("login.athlete")}</span
          ></a
        ><a
          on:click|preventDefault={newUser.coach}
          class="signup-choice__link signup-choice__link--trainer"
          href="/bli-bruker"
          ><span class="signup-choice__link-text">{$_("login.trainer")}</span
          ></a
        ><a
          on:click|preventDefault={newUser.professional}
          class="signup-choice__link signup-choice__link--admin"
          href="/bli-bruker"
          ><span class="signup-choice__link-text"
            >{$_("login.professional")}</span
          ></a
        >
      </div>
    </section>
  {/if}
</div>
